var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.9231C12.2712 14.9231 14.9231 12.2712 14.9231 9C14.9231 5.72878 12.2712 3.07692 9 3.07692C5.72878 3.07692 3.07692 5.72878 3.07692 9C3.07692 12.2712 5.72878 14.9231 9 14.9231ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M11.0863 10.8389V10.9107H11.1581H11.8725H11.9443V10.8389V6.53125V6.45946H11.8725H10.9463H10.9045L10.8839 6.49582L9.21467 9.43807L9.21464 9.43806L9.21372 9.4398C9.17091 9.52033 9.10237 9.66025 9.00841 9.85872C8.96076 9.74561 8.8927 9.60914 8.80514 9.45001L8.805 9.44976L7.16449 6.49639L7.14397 6.45946H7.10173H6.12891H6.05711V6.53125V10.8389V10.9107H6.12891H6.81455H6.88634V10.8389V8.01072C6.88634 7.85549 6.88438 7.71478 6.88041 7.58869C6.88815 7.60492 6.89568 7.61937 6.903 7.63202C6.90308 7.63215 6.90316 7.63228 6.90324 7.63242L8.73357 10.8742L8.75417 10.9107H8.79609H9.19455H9.23658L9.25715 10.8741L11.0912 7.60705C11.0941 7.60204 11.0971 7.59684 11.1 7.59146C11.0909 7.73454 11.0863 7.86597 11.0863 7.98569V10.8389Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.14359
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmBlack);
export default __webpack_public_path__ + "static/media/confirm-black.16dcb1bdef09c907526c1762a284629e.svg";
export { ForwardRef as ReactComponent };